import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { standbyCustomerEntriesQuery } from '@/api/standby/standbyCustomerEntriesQuery';
import { Logger } from '@/utils/logging';
import {
  returnToStandbyEntries,
  returnToStandbyHome,
} from '@/utils/standby/standbyExitNav';

/**
 * Refetches the customer entries (staleTime 0, so a cold cache still counts),
 * then goes Home when none are left, else back; a failed fetch goes Home.
 */
export const useStandbyReturnToApp = (customerId?: string) => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    if (!customerId) {
      returnToStandbyHome();
      return;
    }
    try {
      const data = await queryClient.fetchQuery({
        ...standbyCustomerEntriesQuery(customerId),
        staleTime: 0,
      });
      data.entries.length === 0
        ? returnToStandbyHome()
        : returnToStandbyEntries();
    } catch (error) {
      Logger.error('standby return-to-app: customer entries refetch failed', {
        error,
      });
      returnToStandbyHome();
    }
  }, [queryClient, customerId]);
};
